module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_bold-1dfc22d8d453627ab4ab672a56abc993.woff2";